import LoyaltyReferralLinkSharer from './LoyaltyReferralLinkSharer'

export default LoyaltyReferralLinkSharer
